import { defineComponent } from 'vue';
import { IonImg } from "@ionic/vue";
export default defineComponent({
    name: 'AppLogo',
    components: { IonImg },
    computed: {
        lightLogo() {
            return new URL('@/assets/svg/logo-theme-light.svg', import.meta.url).href;
        },
        darkLogo() {
            return new URL('@/assets/svg/logo-theme-dark.svg', import.meta.url).href;
        },
    }
});
